import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Usuario from '../supabase/Usuario';
import './Register.css';
import logo from './logo.png';

export default function Register(){
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: '',
    correo: '',
    telefono: '',
    codigoPais: '+506',
    tipoDoc: '',
    numDocumento: '',
    usuario: '',
    contrasenna: '',
    confirmar: '',
  });
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [okMsg, setOkMsg] = useState('');

  // Faltan tipos de documento
  const tiposDoc = useMemo(() => ([
    { value: 'CI', label: 'Cédula de identidad' },
    { value: 'PAS', label: 'Pasaporte' },
  ]), []);

  const typeIdMap = { CI: 1, PAS: 2 };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const formatPhone = (cc, raw) => {
    const digits = String(raw || '').replace(/\D+/g, '');
    if (digits.length >= 8) {
      return `${cc} ${digits.slice(0,4)}-${digits.slice(4,8)}${digits.length > 8 ? ' ' + digits.slice(8) : ''}`;
    }
    return `${cc} ${digits}`.trim();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setOkMsg('');
    if ((form.contrasenna || '').length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (form.contrasenna !== form.confirmar) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (!form.tipoDoc) {
      setError('Selecciona un tipo de documento');
      return;
    }
    setLoading(true);
    try {
      // Unicidad: documento, usuario y correo
      const { data: existingDoc } = await Usuario.getByNumDocumento(form.numDocumento);
      if (existingDoc) {
        setError('Ya existe una cuenta con ese número de documento');
        setLoading(false);
        return;
      }
      const uTaken = await Usuario.existsUsuario(form.usuario);
      if (uTaken) {
        setError('El nombre de usuario ya está en uso');
        setLoading(false);
        return;
      }
      const mailTaken = await Usuario.existsCorreo(form.correo);
      if (mailTaken) {
        setError('El correo ya está en uso');
        setLoading(false);
        return;
      }

      const idTipoDoc = typeIdMap[form.tipoDoc] ?? null;
      const idTipoUsuario = 1; // usuario estándar
      const telefonoFormatted = formatPhone(form.codigoPais, form.telefono);
      const ok = await Usuario.register(
        form.numDocumento,
        idTipoUsuario,
        idTipoDoc,
        form.nombre,
        form.usuario,
        form.correo,
        form.contrasenna,
        telefonoFormatted,
        "", // atributo "direccion", se edita dentro del perfil
        "", // atributo "descripcion", se edita dentro del perfil
        0, // cantidad inicial de varitas
        true // estado activo por defecto
      );
      if (ok) {
        setOkMsg('Cuenta creada con éxito.');
        setTimeout(() => navigate('/'), 800);
      } else {
        setError('No se pudo crear la cuenta. Verifica los datos.');
      }
    } catch (err) {
      setError('Ocurrió un error creando la cuenta.');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="app-container">
          <div className="register-page">
          <header className="register-header" role="banner">
            <div className="brand">
              <img src={logo} className="brand-logo" alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" />
              <h1 className="brand-title" id="register-title">Crear cuenta</h1>
            </div>
              <title>ReANIDArt - Registro</title>
          </header>

          <main className="register-main" role="main" aria-labelledby="register-title">
            <form className="register-card" onSubmit={handleSubmit} aria-describedby={(error || okMsg) ? 'register-status' : undefined}>
              <label className="field">
                <span>Nombre completo</span>
                <input name="nombre" value={form.nombre} onChange={onChange} placeholder="Nombre" required />
              </label>

              <label className="field">
                <span>Dirección de correo</span>
                <input type="email" name="correo" value={form.correo} onChange={onChange} placeholder="Correo" required />
              </label>

              <div className="row-2">
                <label className="field">
                  <span>Código de país</span>
                  <select name="codigoPais" value={form.codigoPais} onChange={onChange}>
                    <option value="+506">+506 (CR)</option>
                    <option value="+1">+1 (US)</option>
                    <option value="+34">+34 (ES)</option>
                    <option value="+52">+52 (MX)</option>
                  </select>
                </label>
                <label className="field">
                  <span>Número de teléfono</span>
                  <input name="telefono" value={form.telefono} onChange={onChange} placeholder="Número" inputMode="numeric" />
                </label>
              </div>

              <div className="row-2">
                <label className="field">
                  <span>Documento de identidad</span>
                  <select name="tipoDoc" value={form.tipoDoc} onChange={onChange} required>
                    <option value="" disabled>Tipo de documento</option>
                    {tiposDoc.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </label>

                <label className="field">
                  <span>&nbsp;</span>
                  <input name="numDocumento" value={form.numDocumento} onChange={onChange} placeholder="Número de documento" required />
                </label>
              </div>

              <label className="field">
                <span>Usuario</span>
                <input name="usuario" value={form.usuario} onChange={onChange} placeholder="Usuario (único)" required autoComplete="username" />
              </label>

              <label className="field">
                <span>Contraseña</span>
                <div className="password-wrapper">
                  <input
                    type={show1 ? 'text' : 'password'}
                    name="contrasenna"
                    value={form.contrasenna}
                    onChange={onChange}
                    placeholder="Contraseña (mín. 6 caracteres)"
                    minLength={6}
                    required
                    autoComplete="new-password"
                  />
                  <button type="button" className="toggle-pass" onClick={() => setShow1(s => !s)} aria-label="Mostrar/Ocultar contraseña">
                    {show1 ? '🚫' : '👁️'}
                  </button>
                </div>
              </label>

              <label className="field">
                <span>Confirmar contraseña</span>
                <div className="password-wrapper">
                  <input
                    type={show2 ? 'text' : 'password'}
                    name="confirmar"
                    value={form.confirmar}
                    onChange={onChange}
                    placeholder="Repite la contraseña"
                    minLength={6}
                    required
                    autoComplete="new-password"
                  />
                  <button type="button" className="toggle-pass" onClick={() => setShow2(s => !s)} aria-label="Mostrar/Ocultar confirmación">
                    {show2 ? '🚫' : '👁️'}
                  </button>
                </div>
              </label>

              {(error || okMsg) && (
                <div id="register-status">
                  {error && <div className="error" role="alert" aria-live="assertive">{error}</div>}
                  {okMsg && <div className="ok" role="status" aria-live="polite">{okMsg}</div>}
                </div>
              )}

              <div className="actions row">
                <button type="button" className="btn" onClick={() => navigate('/')}>Cancelar</button>
                <button type="submit" className="btn primary" disabled={loading}>{loading ? 'Creando...' : 'Crear cuenta'}</button>
              </div>
            </form>
          </main>
        </div>
      </div>
  );
}
